import IEventType from '@/types/IEventType';
import { useForm } from 'react-hook-form';

interface IArgs {
	service: IEventType;
	onChange: (values: Partial<IEventType>) => void;
}

export function useSectionPaymentsController(args: IArgs) {
	const form = useForm({
		defaultValues: {
			currency: 'eur',
			unit_amount: 500,
			name: args.service.name,
			quantity: 1,
			id: args.service.id,
		},
	});

	const handleSubmit = form.handleSubmit((values) => {
		return fetch(
			`https://stripe-payments-lyart.vercel.app/api/payments?currency=${values.currency}&name=${encodeURIComponent(
				values.name
			)}&unit_amount=${values.unit_amount}&quantity=${1}&id=${values.id}`
		)
			.then((res) => {
				return res.json();
			})
			.then((res) => {
				return args.onChange({
					...args.service,
					tags: {
						...args.service.tags,
						tt_payment_url: res.url,
					},
				});
			})
			.then(() => {})
			.catch(() => {
				form.reset();
			});
	});

	function handleRemovePaymentLinkClick() {
		return args.onChange({
			...args.service,
			tags: {
				...args.service.tags,
				tt_payment_url: undefined,
			},
		});
	}

	return {
		handleRemovePaymentLinkClick,
		handleSubmit,
		form,
	};
}
